// extracted by mini-css-extract-plugin
module.exports = {"LoadingRelatedPersonsCard":"member-operations__LoadingRelatedPersonCard__LoadingRelatedPersonsCard"};